export function toArray(value) {
    if (Array.isArray(value)) {
        return value;
    }
    return value !== undefined ? [value] : [];
}
export function toInnerValue(value, { labelInValue, combobox }) {
    const valueMap = new Map();
    if (value === undefined || (value === '' && combobox)) {
        return [[], valueMap];
    }
    const values = Array.isArray(value) ? value : [value];
    let rawValues = values;
    if (labelInValue) {
        rawValues = values
            .filter(item => item !== null)
            .map((itemValue) => {
            const { key, value: val } = itemValue;
            const finalVal = val !== undefined ? val : key;
            valueMap.set(finalVal, itemValue);
            return finalVal;
        });
    }
    return [rawValues, valueMap];
}
export function toOuterValues(valueList, { optionLabelProp, labelInValue, prevValueMap, options, getLabeledValue, }) {
    let values = valueList;
    if (labelInValue) {
        values = values.map(val => getLabeledValue(val, {
            options,
            prevValueMap,
            labelInValue,
            optionLabelProp,
        }));
    }
    return values;
}
export function removeLastEnabledValue(measureValues, values) {
    const newValues = [...values];
    let removeIndex;
    for (removeIndex = measureValues.length - 1; removeIndex >= 0; removeIndex -= 1) {
        if (!measureValues[removeIndex].disabled) {
            break;
        }
    }
    let removedValue = null;
    if (removeIndex !== -1) {
        removedValue = newValues[removeIndex];
        newValues.splice(removeIndex, 1);
    }
    return {
        values: newValues,
        removedValue,
    };
}
export const isClient = typeof window !== 'undefined' && window.document && window.document.documentElement;
export const isBrowserClient = process.env.NODE_ENV !== 'test' && isClient;
let uuid = 0;
export function getUUID() {
    let retId;
    if (isBrowserClient) {
        retId = uuid;
        uuid += 1;
    }
    else {
        retId = 'TEST_OR_SSR';
    }
    return retId;
}
